import { render } from "./KoruMultipleUpload.vue?vue&type=template&id=47c68a42&ts=true"
import script from "./KoruMultipleUpload.vue?vue&type=script&lang=ts"
export * from "./KoruMultipleUpload.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__